import React from "react";
import { Link } from "react-router-dom";
import "./index.css";

const AuthLegalLinks = () => (
    <nav className="auth-legal-links" aria-label="Legal links">
        <Link className="about-info-button auth-legal-links__link" to="/privacy">
            Privacy
        </Link>
        <Link className="about-info-button auth-legal-links__link auth-legal-links__link--wide" to="/legal/foursquare-os-places">
            Foursquare OS Places
        </Link>
    </nav>
);

export default AuthLegalLinks;
